<template>
  <div class="contain page4-con" id="Mobile4">
    <div class="con">
      <div class="con-head title-box">
        <div class="title-chinese">
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
          <h3>指定实验室</h3>
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
        </div>
        <div class="title-english">
          <p class="about" style="color: #666">ACCREDITED LABORATORIES</p>
        </div>
      </div>
      <div class="content">
        <ul class="myMain">
          <li v-for="(item, index) in laboratory" :key="index" @click="gotoDetail(item)">
            <el-card shadow="hover">
              <img :src="item.img" alt="" />
              <p v-html="item.name" class="laboratory-name"></p>
              <!-- <span>{{ item.type }}</span> -->
            </el-card>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <div class="footer-inner"></div>
      <div class="myMain" >
        <div class="expert-title">专家数量</div>
        <div class="expert-content">
          <div class="expert-item" v-for="item in expertCount" :key="item.id">
            <div><span class="expert-item-number">{{ item.count }}</span><span class="expert-item-unit"> 人</span></div>
            <div class="expert-item-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <!-- <template>
        <div class="myMain" style="position: relative">
          <el-tabs v-model="activeName" @tab-click="handleTabClick">
            <el-tab-pane label="验收专家" name="0">
              <ul>
                <li v-for="(item, index) in expertList" :key="index">
                 
                  <div class="right">
                    <div>
                      <h4>{{ item.name }}</h4>
                      <p class="level">{{ getTitle(item.title) ? getTitle(item.title) : item.brief }}</p>
                      <p class="desc">{{ item.content }}</p>
                    </div>
                  </div>
                </li>
                <i /><i />
              </ul>
            </el-tab-pane>
            <el-tab-pane label="划线师" name="1">
              <ul>
                <li v-for="(item, index) in expertList" :key="index">
                  <div class="right">
                    <div>
                      <h4>{{ item.name }}</h4>
                      <p class="level">{{  getTitle(item.title) ? getTitle(item.title) : item.brief }}</p>
                      <p class="desc">{{ item.content }}</p>
                    </div>
                  </div>
                </li>
                <i /><i />
              </ul>
            </el-tab-pane>
            <el-tab-pane label="专家智库" name="2">
              <ul>
                <li v-for="(item, index) in expertList" :key="index">
                  <div class="right">
                    <div>
                      <h4>{{ item.name }}</h4>
                      <p class="level">{{  getTitle(item.title) ? getTitle(item.title) : item.brief }}</p>
                      <p class="desc">{{ item.content }}</p>
                    </div>
                  </div>
                </li>
                <i /><i />
              </ul>
            </el-tab-pane>
          </el-tabs>
          <div class="moreBox">
            <p @click="junpHandel">查看更多</p>
            <i>></i>
          </div>
        </div>
      </template> -->
    </div>
  </div>
</template>

<script>
import { getLabList, getExpertList } from "@/api/home/index";
export default {
  data() {
    return {
      laboratory: [],
      activeName: "0",
      expertList: [],
      expertParams: {
        show: 1,
        type: 0,
      },
      expertCount: [{
        id: 'e1',
        name: '验收专家',
        count: 226
      }, {
        id: 'e2',
        name: '划线师',
        count: 161
      }, {
        id: 'e3',
        name: '专家智库',
        count: 208
      }]
    };
  },
  created() {
    getLabList({ show: 1 }).then((res) => {
      this.laboratory = res.data.list;
    });
    this.getExpertData();
  },
  methods: {
    // 查询验收专家
    getTitle(value){
      if(value > 0 && value < 4){
      var text = [null,"教授","副教授","高级工程师"];
      return text[value];
      }else{
        return null;
      }
    },
    getExpertData() {
      getExpertList(this.expertParams).then((res) => {
        this.expertList = res.data.list;
      });
    },
    handleTabClick(tab) {
      const index = tab.name;
      this.expertParams.type = index;
      this.getExpertData();
    },
    //跳转
    junpHandel() {
      this.$router.push({
        path: "/expert",
      });
    },
    gotoDetail(item){
      this.$router.push(`/lab?id=${item.id}&type=lab`);
    }
  },
};
</script>

<style lang="scss" scoped>
.page4-con {
  width: 100%;
  height: 100%;
  background: #f6f6f6;
}
.page4-con .con {
  height: 50%;
  overflow: hidden;
  padding-top: 80px;
  box-sizing: border-box;
  .con-head .el-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .el-col-6 {
      width: 20%;
    }
    .el-col {
      h3 {
        font-size: 38px;
        color: #da5351;
      }
      .line {
        width: 85px;
        height: 2px;
        background-color: #d8d8d8;
        display: none;
      }
      .line:last-child {
        margin-top: 2px;
      }
    }
    p.about {
      font-size: 18px;
      margin-top: 16px;
      margin-bottom: 26px;
    }
  }

  .content {
    ul {
      display: flex;
      // flex-direction: row;
      // flex-wrap: wrap;
      margin: 0 auto;
      justify-content: center;
      padding-top: 20px;
      padding-bottom: 35px;
      box-sizing: border-box;

      li {
        width: 216px;
        height: 225px;
        margin: 0 15px 10px 15px;
        margin-bottom: 10px;
        // margin-top: 10px;
        background-color: #fff;
        color: #222;
        box-sizing: border-box;
        border-radius: 4px;
        transition: all 0.3s ease-in-out;
        position: relative;
        cursor: pointer;
        bottom: 0;
        img {
          width: 100px;
          height: 100px;
        }
        p {
          margin-top: 30px;
          font-size: 16px;
          line-height: 20px;
          padding: 0 20px;
        }
        // width: 33.33%;
      }
      li:hover {
        bottom: 6px;
        box-shadow: 0 6px 18px 0 rgba(232, 237, 250, 0.5);
      }
    }
  }
}
.page4-con .footer {
  width: 100%;
  background: url("../../../assets/image/home/osports1.jpg") no-repeat;
  background-position: center;
  // background-color: red;
  background-size: 100% auto;
  border: 1px solid #979797;
  box-sizing: border-box;
  position: relative;
  padding: 3% 0;
  .footer-inner{
    background: rgba(0, 0, 0, .6);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .expert-title{
    // border-bottom: 1px solid #e13626;
    width: 100%;
    text-align: left;
    color: #fff;
    font-size: 32px;
    position: relative;
    // height: 50px;
    margin-bottom: 30px;
  }
  // .expert-title::after{
  //   content: '';
  //   position: absolute;
  //   left: 0;
  //   bottom: 0;
  //   width: 112px;
  //   height: 8px;
  //   border-radius: 1px;
  //   background: #e13626;
  // }
  .expert-content{
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;
    .expert-item{
      width: 33.3%;
      .expert-item-number{
        font-family: FZZJ-HLYHXSJW,FZZJ;
        font-weight: 400;
        font-size: 46px;
      }
      .expert-item-unit{
        font-size: 20px;
      }
      .expert-item-name{
        font-size: 20px;
        margin-top: 20px;
      }
    }
  }
}
// .page4-con .footer {
//   width: 100%;
//   height: 50%;
//   background: url("../../../assets/image/home/osports.png");
//   border: 1px solid #979797;
//   padding: 3% 5%;
//   box-sizing: border-box;
//   position: relative;
//   .el-tabs {
//     margin: 0 auto;
//   }
//   .el-tabs__content ul {
//     display: flex;
//     flex-direction: row;
//     flex-wrap: wrap;
//     justify-content: space-between;
//     padding-top: 20px;
//     box-sizing: border-box;
//   }
  
//   .el-tabs__content ul > i{
//     width: 33.33%;
//   }
//   .el-tabs__content ul > li {
//     display: flex;
//     flex-direction: row;
//     margin-bottom: 30px;
//     width: 33.33%;
//     img {
//       width: 80px;
//       height: 80px;
//     }
//     .left {
//       margin-right: 4%;
//       img {
//         border-radius: 50%;
//       }
//     }
//     .right {
//       text-align: left;
//       width: calc(100% - 80px - 4%);
//       h4 {
//         font-size: 18px;
//       }
//       p {
//         font-size: 16px;
//       }
//       p.level {
//         font-size: 14px;
//         color: #b2b2b2;
//         margin-top: 6px;
//         margin-bottom: 8px;
//       }
//       .desc {
//         overflow: hidden;
//         text-overflow: ellipsis;
//         white-space: nowrap;
//       }
//       button {
//         width: 80px;
//         height: 28px;
//         margin-top: 16px;
//         border-radius: 30px;
//         background-color: #da5351;
//         color: #fff;
//         border: none;
//         font-size: 12px;
//         cursor: pointer;
//       }
//     }
//   }
//   .moreBox {
//     position: absolute;
//     right: 0;
//     top: 3%;
//     height: 22px;
//     font-size: 18px;
//     color: #999999;
//     line-height: 22px;
//     display: flex;
//     cursor: pointer;
//     p {
//       margin-right: 8px;
//     }
//     i {
//       display: inline-block;
//       background-color: #fff;
//       width: 22px;
//       height: 22px;
//       border-radius: 50%;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       font-size: 14px;
//     }
//   }
// }
// 移动端
@media screen and (max-width: 960px) {
  #Mobile4 {
    .con {
      padding-top: 0.24rem;
      height: 100%;
    }
    .content {
      ul {
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 0 0.16rem 0.08rem 0.16rem;

        li {
          width: 1.06rem;
          height: 0.96rem;
          margin: 0 0.12rem 0.16rem 0.12rem;
          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(6) {
            margin: 0;
          }

          img {
            width: 0.44rem;
            height: 0.44rem;
          }
          p,
          span {
            font-size: 0.12rem;
            line-height: 0.17rem;
          }
          p {
            margin-top: 0.08rem;
            padding: 0 .05rem;
          }
        }
      }
    }
    .footer {
      // background: none;
      border: none;
      // background-color: #fff;
      padding: 0.08rem 0.16rem .2rem 0.16rem;
      // color: #222;
      .expert-title{
        // color: #222;
        font-size: .14rem;
        line-height: .2rem;
        margin-bottom: .12rem;
      }
      // .expert-title::after{
      //   width: .6rem;
      //   height: .04rem;
      // }
  .expert-content{
    .expert-item{
      .expert-item-number{
        font-size: .18rem;
      }
      .expert-item-unit{
        font-size: .12rem;
      }
      .expert-item-name{
        margin-top: .06rem;
        font-size: .12rem;
      }
    }
  }
      // ul {
      //   li {
      //     width: 100%;
      //     border-bottom: 0.01rem #f1f1f1 solid;
      //     margin: 0 0 0.14rem 0;
      //     padding-bottom: 0.14rem;
      //     &:nth-child(n + 4) {
      //       display: none;
      //     }
      //     &:nth-child(3) {
      //       border: none;
      //     }
      //     .left {
      //       margin-right: 0.12rem;
      //       img {
      //         border-radius: 50%;
      //         width: 0.46rem;
      //         height: 0.46rem;
      //       }
      //     }
      //     .right {
      //       display: flex;
      //       width: 100%;
      //       align-items: center;
      //       justify-content: space-between;
      //       div {
      //         width: 1.58rem;
      //         overflow: hidden;
      //         h4 {
      //           font-size: 0.16rem;
      //           line-height: 0.22rem;
      //           font-weight: 500;
      //           color: #222222;
      //         }
      //         .level {
      //           font-size: 0.14rem;
      //           font-weight: 400;
      //           color: #666666;
      //           line-height: 0.16rem;
      //           margin: 0.04rem 0 0.08rem 0;
      //         }
      //         .desc {
      //           font-size: 0.12rem;
      //           font-weight: 400;
      //           color: #999999;
      //           line-height: 0.12rem;
      //           white-space: nowrap;
      //           text-overflow: ellipsis;
      //           overflow: hidden;
      //         }
      //       }

      //       button {
      //         width: 0.78rem;
      //         height: 0.3rem;
      //         font-size: 0.12rem;
      //         font-weight: 400;
      //         color: #ffffff;
      //         margin: 0;
      //       }
      //     }
      //   }
      // }
      // .moreBox {
      //   font-size: 0.12rem;
      //   line-height: 0.16rem;
      //   top: 0.1rem;
      //   display: flex;
      //   align-items: center;
      //   p {
      //     margin-right: 0.08rem;
      //   }
      //   i {
      //     width: 0.04rem;
      //     height: 0.07rem;
      //   }
      // }
    }
  }
}
</style>

<style lang="scss">
.page4-con {
  .el-card {
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 4px;
    .el-card__body {
      padding: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .el-tabs__item {
    color: #fff !important;
    height: 50px !important;
    font-size: 24px;
  }
  .el-tabs__nav-wrap::after {
    height: 1px;
    background: #da5351 !important;
  }
  .el-tabs__item.is-active {
    color: #fff !important;
    font-size: 28px;
  }
  .el-tabs__item:hover {
    color: #fff !important;
  }
  .el-tabs__active-bar {
    height: 8px !important;
    border-radius: 1px !important;
    background: #e13626 !important;
  }
    .laboratory-name p{
      word-break: keep-all;
      white-space: nowrap;
    }
}
@media screen and (max-width: 768px) {
  #Mobile4 {
    .el-tabs__item {
      color: #666666 !important;
      height: 0.4rem !important;
      font-size: 0.14rem;
      padding: 0 0.1rem;
    }
    .el-tabs__nav-wrap::after {
      height: 0.01rem;
      background: #f1f1f1 !important;
    }
    .el-tabs__item.is-active {
      color: #cc3b3f !important;
      font-size: 0.16rem;
    }
    .el-tabs__item:hover {
      color: #cc3b3f !important;
    }
    .el-tabs__active-bar {
      height: 0.02rem !important;
      border-radius: 0.01rem !important;
      background: #cc3b3f !important;
    }
    // .el-tabs__item {
    //   font-size: 0.14rem;
    //   font-weight: 400;
    //   color: #666666 !important;
    //   line-height: 0.16rem;
    //   height: 0.16rem !important;
    //   margin-bottom: 0.12rem;
    // }
    // .el-tabs__active-bar {
    //   width: 0.64rem !important;
    //   height: 0.02rem !important;
    //   background: #cc3b3f;
    //   border-radius: 0.01rem;
    // }

    // .el-tabs__item.is-active {
    //   height: 0.16rem;
    //   font-size: 0.16rem;
    //   color: #cc3b3f !important;
    //   line-height: 0.16rem;
    // }
  }
}
</style>
